var _circle, _circle2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 40,
    viewBox: "0 0 92 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_1_153)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "url(#paint1_linear_1_153)",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1008 13.021L17.179 26.9963L20.579 27.0065L25.7408 13.0618L22.7408 13.0529L18.8676 24.1413L15.0808 13.0299L12.1008 13.021Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1008 13.021L11.1609 13.3626L10.6719 12.0168L12.1038 12.021L12.1008 13.021ZM17.179 26.9963L17.176 27.9963L16.4777 27.9942L16.2392 27.3378L17.179 26.9963ZM20.579 27.0065L21.5168 27.3536L21.2744 28.0085L20.576 28.0064L20.579 27.0065ZM25.7408 13.0618L25.7437 12.0618L27.1756 12.0661L26.6786 13.409L25.7408 13.0618ZM22.7408 13.0529L21.7967 12.7231L22.0316 12.0507L22.7438 12.0529L22.7408 13.0529ZM18.8676 24.1413L19.8116 24.4711L18.8559 27.2071L17.921 24.4639L18.8676 24.1413ZM15.0808 13.0299L15.0838 12.0299L15.7972 12.0321L16.0273 12.7074L15.0808 13.0299ZM13.0407 12.6795L18.1189 26.6548L16.2392 27.3378L11.1609 13.3626L13.0407 12.6795ZM17.182 25.9963L20.582 26.0065L20.576 28.0064L17.176 27.9963L17.182 25.9963ZM19.6412 26.6593L24.8029 12.7147L26.6786 13.409L21.5168 27.3536L19.6412 26.6593ZM25.7378 14.0618L22.7378 14.0529L22.7438 12.0529L25.7437 12.0618L25.7378 14.0618ZM23.6848 13.3826L19.8116 24.4711L17.9235 23.8116L21.7967 12.7231L23.6848 13.3826ZM17.921 24.4639L14.1343 13.3525L16.0273 12.7074L19.8141 23.8187L17.921 24.4639ZM15.0778 14.0299L12.0978 14.021L12.1038 12.021L15.0838 12.0299L15.0778 14.0299Z",
    fill: "url(#paint2_linear_1_153)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.48 13.1L53.26 27H50.62L45.38 13.1H47.82L51.94 24.66L56.08 13.1H58.48ZM62.6667 12.2V27H60.3867V12.2H62.6667ZM64.9002 21.44C64.9002 20.3333 65.1268 19.3533 65.5802 18.5C66.0468 17.6467 66.6735 16.9867 67.4602 16.52C68.2602 16.04 69.1402 15.8 70.1002 15.8C70.9668 15.8 71.7202 15.9733 72.3602 16.32C73.0135 16.6533 73.5335 17.0733 73.9202 17.58V15.98H76.2202V27H73.9202V25.36C73.5335 25.88 73.0068 26.3133 72.3402 26.66C71.6735 27.0067 70.9135 27.18 70.0602 27.18C69.1135 27.18 68.2468 26.94 67.4602 26.46C66.6735 25.9667 66.0468 25.2867 65.5802 24.42C65.1268 23.54 64.9002 22.5467 64.9002 21.44ZM73.9202 21.48C73.9202 20.72 73.7602 20.06 73.4402 19.5C73.1335 18.94 72.7268 18.5133 72.2202 18.22C71.7135 17.9267 71.1668 17.78 70.5802 17.78C69.9935 17.78 69.4468 17.9267 68.9402 18.22C68.4335 18.5 68.0202 18.92 67.7002 19.48C67.3935 20.0267 67.2402 20.68 67.2402 21.44C67.2402 22.2 67.3935 22.8667 67.7002 23.44C68.0202 24.0133 68.4335 24.4533 68.9402 24.76C69.4602 25.0533 70.0068 25.2 70.5802 25.2C71.1668 25.2 71.7135 25.0533 72.2202 24.76C72.7268 24.4667 73.1335 24.04 73.4402 23.48C73.7602 22.9067 73.9202 22.24 73.9202 21.48ZM78.4548 21.44C78.4548 20.3333 78.6815 19.3533 79.1348 18.5C79.6015 17.6467 80.2282 16.9867 81.0148 16.52C81.8148 16.04 82.7015 15.8 83.6748 15.8C84.3948 15.8 85.1015 15.96 85.7948 16.28C86.5015 16.5867 87.0615 17 87.4748 17.52V12.2H89.7748V27H87.4748V25.34C87.1015 25.8733 86.5815 26.3133 85.9148 26.66C85.2615 27.0067 84.5082 27.18 83.6548 27.18C82.6948 27.18 81.8148 26.94 81.0148 26.46C80.2282 25.9667 79.6015 25.2867 79.1348 24.42C78.6815 23.54 78.4548 22.5467 78.4548 21.44ZM87.4748 21.48C87.4748 20.72 87.3148 20.06 86.9948 19.5C86.6882 18.94 86.2815 18.5133 85.7748 18.22C85.2682 17.9267 84.7215 17.78 84.1348 17.78C83.5482 17.78 83.0015 17.9267 82.4948 18.22C81.9882 18.5 81.5748 18.92 81.2548 19.48C80.9482 20.0267 80.7948 20.68 80.7948 21.44C80.7948 22.2 80.9482 22.8667 81.2548 23.44C81.5748 24.0133 81.9882 24.4533 82.4948 24.76C83.0148 25.0533 83.5615 25.2 84.1348 25.2C84.7215 25.2 85.2682 25.0533 85.7748 24.76C86.2815 24.4667 86.6882 24.04 86.9948 23.48C87.3148 22.9067 87.4748 22.24 87.4748 21.48Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_153",
    x1: 34,
    y1: -0.00000184178,
    x2: 7,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C7015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_153",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55BF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_153",
    x1: 18.5448,
    y1: 5.00027,
    x2: 18.4551,
    y2: 35.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55BF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.28dea23e5ffb4e05ff35a55b31929ee0.svg";
export { ForwardRef as ReactComponent };